<div class="exception-body error">
    <div class="exception-content">
        <div class="exception-title">Erreur technique</div>
        <div class="exception-detail">Une erreur technique est survenue.</div>
        <a href="/">Retour à l'accueil</a>
    </div>
</div>
